import { extendTheme } from '@chakra-ui/react';
const themeProps = extendTheme({
  ...extendTheme,
  fonts: {
    heading: 'var(--FedraSerif)',
    body: 'var(--FedraSansStd-book)',
    // body: 'var(--font-zilla-Slab)',
    // heading: 'var(--FedraSerif)',
  },
});

export const ishaTheme = themeProps;
